import { render, staticRenderFns } from "./MeterTypeComponent.vue?vue&type=template&id=5522930f"
import script from "./MeterTypeComponent.vue?vue&type=script&lang=js"
export * from "./MeterTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports